import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import StatsNumber from '../StatsNumber'
import StatsCircular from '../StatsCircular'

import ModelsTooltip from './ModelsTooltip'
import NegativeBuyerRatings from './NegativeBuyerRatings'

function Models({ data = {
  models_count: 0,
  models_to_imporive: 0,
  average_publish_score: 0,
  positive_rating_count: 0,
  negative_rating_count: 0,
} }) {
  const negativePublishScore = 6
  const modelsBarColor = data.models_count < data.models_to_imporive ? '#19bcc9' : '#CE3C5C'
  const modelsBarBgColor = data.models_to_imporive === 0 ? '#19bcc9' : '#F7F7F7'
  const scoreTooltip = `This number shows the average publishing score of all your models. To improve the publishing
     score of a model, you can:
    <ul>
      <li>upload additional file formats,</li>
      <li>add more preview images,</li>
      <li>add model tags,</li>
      <li>make the description longer.</li>
    </ul>`
  // Format total models
  const totalModels = data.models_count < 10000 ? '0' : data.models_count < 100000 ? '0.0a' : '0a'
  const modelsImproveTooltip = data.models_to_imporive === 0
    ? 'Your model presentation is pretty good! Want to make it even better? Go to '
    + '<a href="/profile/analytics/improvements" target="_blank">Model Improvements</a>'
    : <ModelsTooltip value={data.models_to_imporive} />

  return (
    data.models_count > 0 ? (
      <div>
        <div className="row">
          <div className="col-6 stats-circular">
            <StatsCircular
              value={data.models_to_imporive}
              maxValue={data.models_count}
              displayValue={data.models_count}
              title="Published"
              format={totalModels}
              tooltip={modelsImproveTooltip}
              barColor={modelsBarColor}
              barBgColor={modelsBarBgColor}
              html={data.models_to_imporive === 0}
            />
          </div>
          <div className="col-6 stats-tooltip-container">
            <Tooltip
              tooltipClassName="tooltip--medium"
              id="dashboard__stats-models-score"
              content={scoreTooltip}
              html
            >
              <div className="stats-element models-avg-score">
                <div className="stats-element__value">
                  <span className={data.average_publish_score < negativePublishScore ? 'is-negative' : 'is-positive'}>
                    {data.average_publish_score}
                  </span>
                </div>
                <div className="stats-element__title">Avg. Publishing Score</div>
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="stats-separator-text stats-tooltip-container">
              <Tooltip
                tooltipClassName="tooltip--medium"
                id="dashboard__stats-models-ratings"
                content="Feedback on models left by your customers."
              >
                Buyer ratings:
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="row stats-bottom-row">
          <div className="col-6 stats-tooltip-container">
            <StatsNumber
              value={data.positive_rating_count}
              title="Positive"
              format="0"
              textColor={data.positive_rating_count === 0 ? '' : 'is-positive'}
            />
          </div>
          <div className="col-6 stats-tooltip-container">
            <NegativeBuyerRatings
              count={data.negative_rating_count}
              statsNumber={(
                <StatsNumber
                  value={data.negative_rating_count}
                  title="Negative"
                  format="0"
                  textColor={data.negative_rating_count === 0 ? 'is-positive' : 'is-negative'}
                />
              )}
            />
          </div>
        </div>
      </div>
    ) : (
      <div className="no-models">
        <div className="no-models__title">You have no models</div>
        <a href="/profile/upload/model" className="btn btn-primary btn-sm">Upload 3D Model</a>
      </div>
    )
  )
}

Models.propTypes = {
  data: PropTypes.shape({
    models_count: PropTypes.number,
    models_to_imporive: PropTypes.number,
    average_publish_score: PropTypes.number,
    positive_rating_count: PropTypes.number,
    negative_rating_count: PropTypes.number,
  }).isRequired,
}

export default Models
